import React, { FC } from 'react';

import { FlexibleDiv } from '@components/formStyles';
import { getLocationIcon } from '@components/ui/search/SearchLocation/utils/getLocationIcon';
import CustomIcon from '@components/utils/CustomIcon';
import { BookerSearchViewModel } from '@components/views/landing/components/booker/common/BookerSearchDrawer';
import { DeleteBin5Line } from '@assets/icons';

import {
  IconButton,
  ItelLabel,
  ItemWrapper,
  LabelWrapper,
  SubLabel,
  Wrapper,
} from './styled';

interface IItem {
  label?: string;
  subLabel?: string;
  type: BookerSearchViewModel['type'];
  onClick?: () => void;
  handleRemove?: () => void;
}

const Item: FC<IItem> = ({
  label = '',
  type = '',
  onClick,
  handleRemove,
  subLabel = '',
}) => {
  /**
   * Remove item from past searches
   * @param e MouseEvent
   */
  const handleRemoveItem = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handleRemove?.();
  };

  return (
    <ItemWrapper onClick={onClick}>
      <Wrapper>
        <CustomIcon
          width={24}
          height={24}
          fontSize={24}
          paletteColor='grey800'
          icon={getLocationIcon(type || '')}
        />
        <FlexibleDiv right={12} />
        <LabelWrapper>
          <ItelLabel>{label}</ItelLabel>
          {subLabel ? <SubLabel>{subLabel}</SubLabel> : null}
        </LabelWrapper>
      </Wrapper>

      {typeof handleRemove === 'function' ? (
        <IconButton onClick={handleRemoveItem}>
          <CustomIcon
            icon={DeleteBin5Line}
            fontSize={16}
            paletteColor='grey800'
          />
        </IconButton>
      ) : null}
    </ItemWrapper>
  );
};

export default Item;
